import React from 'react';
import cx from 'classnames';

import classes from './Table.module.scss';

interface IProps {
  className?: string;
  children: React.ReactNode;
}

const Header: React.FC<IProps> = ({ className, children }) => (
  <tbody className={cx(classes.body, className)}>{children}</tbody>
);

export default Header;
